import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type DeleteTimeLogErrorModalProps = {
  open: boolean
  handleClose: VoidFunction
}

export function DeleteTimeLogErrorModal({ open, handleClose }: Readonly<DeleteTimeLogErrorModalProps>) {
  const { t } = useTranslation()

  return (
    <Modal open={open} onClose={handleClose}>
      <AcknowledgeModal
        result="negative"
        title={t('dialog.volunteering.deleteTimeLog.error.title')}
        description={t('dialog.volunteering.deleteTimeLog.error.description')}
        buttonText={t('button.close')}
        handleClose={handleClose}
      />
    </Modal>
  )
}
